module.exports = __webpack_public_path__ + "img/hospitium-01.7ae8f11c.jpg";